import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolBar } from '../../app/components/ToolBar';
import { Form } from './components/Form';
import { selectFeedback } from './shopsSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LinkedUsers } from '../../app/components/LinkedUsers';
import { LinkedFields } from '../../app/components/LinkedFields';
import { Nav } from './components/ToolBarNav';
import { Actions } from './components/ToolBarActions';
import { create } from './actions';
import {defaultShop} from './util';
import {cloneDeep} from 'lodash';

export function AddShop() {
  const dispatch = useAppDispatch();
  const feedback = useAppSelector(selectFeedback);
  const navigate = useNavigate();

  const [localeShop, setLocaleShop] = useState<Shop>(defaultShop());
  const [localeLinkedUsers, setLocaleLinkedUsers] = useState<User[]>([]);
  const [localeLinkedFields, setLocaleLinkedFields] = useState<FieldDefinition[]>([]);

  const updateShop = useCallback((key: string, value: string) => {
    setLocaleShop({ ...localeShop, [key]: value });
  }, [localeShop]);

  const linkUsers = useCallback((users: User[], linked: boolean) => {
    // Add user to linked users
    if (linked) {
      setLocaleLinkedUsers([...localeLinkedUsers, ...users])
    } else {
      // Remove user from linked users
      const newList = localeLinkedUsers.reduce((acc, curr) => {
        if (users.find(user => user.id === curr.id)) {
          return acc;
        }
        acc.push(curr);
        return acc;
      }, [] as User[]);
      setLocaleLinkedUsers(newList);
    }
  }, [localeLinkedUsers]);

  const LinkField = useCallback((field: FieldDefinition, linked: boolean) => {
    // Add field to linked fields
    if (linked) {
      if (localeLinkedFields.find(curr => curr.id === field.id)) {
        return;
      }
      setLocaleLinkedFields([...localeLinkedFields, field])
    } else {
      // Remove field from linked fields
      setLocaleLinkedFields(localeLinkedFields.filter(curr => curr.id !== field.id));
    }
  }, [localeLinkedFields]);

  const onSubmit = useCallback(() => {
    const cb = () => {
      navigate('/shops');
    };
    const newShop = cloneDeep(localeShop);
    newShop.users = localeLinkedUsers;
    newShop.fieldDefinitions = localeLinkedFields;
    dispatch(create({ shop: newShop, cb }));
  }, [dispatch, navigate, localeShop, localeLinkedUsers, localeLinkedFields]);

  return (
    <>
      <ToolBar title='shops.add' nav={<Nav />} actions={<Actions onSave={onSubmit} disabled={feedback.isWaiting} />} />
      <div className='flex space-x-2 justify-between'>
        <Form onSubmit={onSubmit} shop={localeShop} onChange={updateShop}>
          <LinkedFields onChange={LinkField} assigendFields={feedback.isWaiting ? null : localeLinkedFields} />
          </Form>
        <LinkedUsers onChange={linkUsers} assigendUsers={localeLinkedUsers} />
      </div>
    </>
  )
}
